export default __webpack_public_path__ + "828abcb200061cffbaae1f0498f821a8.ttf";